import consumer from "./consumer"
import { handleInitMessageGroup } from '../customs/share_module'

let loadCount = 0;
$(document).on('turbolinks:load', function() {
  if (typeof current_user_token === 'undefined' || current_user_token === "") {
    return;
  }

  loadCount += 1;
  if (loadCount > 1) {
    return;
  }

  consumer.subscriptions.create({
    channel: "FriendChannel",
    user_token: current_user_token,
  }, {
    connected() {
      console.log("Connected to the FriendChannel!");
      // Called when the subscription is ready for use on the server
    },

    disconnected() {
      // Called when the subscription has been terminated by the server
    },

    received(data) {
      const currentUserId = parseInt(sessionStorage.getItem('current_user_id'))
      if (data.affectUserId == currentUserId) {
        const room = roomList.find( (item) => item.dirrectUserId == data.userId)

        $(`li.contact-user-id-${data.userId}`).remove();
        $(`li.request-user-id-${data.userId}`).remove();

        if (room) {
          $(`#conversation-no-${room.id}`).remove();
          this.delete_from_conversation(room.id, 'dirrect')
        }
      }

      if (data.userId == currentUserId) {
        const room = roomList.find( (item) => item.dirrectUserId == data.affectUserId)
        if (room) {
          this.delete_from_conversation(room.id, 'dirrect')
        }
      }
      this.reload_statistic_contact();
    },
    delete_from_conversation(room_id, room_type) {
      if ($('#my-chat-history').attr('room_id') == room_id) {
        $(`#wrapper-conversation-${room_id} .user-chat-remove`).click();
      }
      $("#conversation-no-" + room_id).remove();
      let room_index = roomList.findIndex(element => element.id === room_id);
      roomList.splice(room_index, 1);
      handleInitMessageGroup();
      this.reload_statistic(room_type);
    },
    reload_statistic(room_type) {
      if (room_type == 'dirrect') {
        var total = 0;
        $(".chat-user-list .rounded-pill").each(function(e) {
          if ($(this).text()) {
            total += parseInt($(this).text());
          }
        })
        if (total > 0) {
          $("#dirrect-message-counter").text(total);
        } else {
          $("#dirrect-message-counter").removeClass("notify-counter");
          $("#dirrect-message-counter").text("");
        }
      }
    },
    reload_statistic_contact() {
      const total = $("#pills-requests .contact-list li").length;
      if (total > 0) {
        $(".friend-request-counter").text(total);
      } else {
        $("#pills-requests-tab").hide();
        $(".friend-request-counter").removeClass("notify-counter");
        $(".friend-request-counter").text("");
      }
    },
  })
});
